<big-ui-card [hasLink]="!!data.link">
    <div
        *transloco="let t; prefix: 'uiCard'"
        class="p-6 text-lg font-ci"
        [ngClass]="classList">
        @if (data.link) {
            <big-ui-link
                class="text-primary dark:text-white"
                [href]="data.link.href"
                [linkClass]="'flex grow items-center font-bold no-underline after:absolute after:inset-0 focus-visible:outline-none hover:bg-transparent'">
                @if (data.svgIcon) {
                    <big-ui-svg-icon
                        [url]="data.svgIcon"
                        [ngClass]="iconSvgCssClass" />
                } @else if (data.icon) {
                    <big-icon
                        [icon]="data.icon"
                        [size]="'w-14'"
                        [ngClass]="iconCssClass" />
                }

                @if (data.link.title) {
                    <ng-container class="w-full">{{ data.link.title }}</ng-container>
                } @else {
                    {{ t('readMore') }}
                }
            </big-ui-link>
        }
    </div>
</big-ui-card>
